export default __webpack_public_path__ + "static/media/Trail.7a183aee.jpg";